import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamCSCZ() {
  return (
    <div className={styles["declaration"]}>
      <h1>Prohlášení o shodě pro školení a zkoušky terénních pracovníků</h1>

      <p>
        Ve snaze o neustálé zlepšování kvality služeb externích prodejců v první linii poskytuje školicí tým mezinárodního oddělení společnosti Xiaomi (dále jen „my“, „naše společnost“ apod.) školení a doprovodné zkoušky s cílem zvyšovat znalosti externích prodejců (dále jen „účastníci školení“), určených poskytovateli outsourcingových služeb. Cílem školení a zkoušky je optimalizovat obsah kurzu a konsolidovat výsledky učení a nepředstavuje žádnou formu pracovního vztahu ani manažerského chování. Následující prohlášení se týká školení a zkoušky:
      </p>

      <ol>
        <li>
          <strong>Povaha školení a zkoušky</strong><br/>
          Všechna školení a zkoušky se provádí za účelem sdílení znalostí a jejich cílem je pomoci účastníkům školení systematicky porozumět informacím o produktech a standardům služeb atd. Výsledky zkoušek odrážejí pouze pochopení obsahu školení jeho účastníky a neslouží jako základ pro hodnocení výkonnosti. Nemáme žádnou pravomoc a nebudeme zasahovat do hodnocení výkonnosti poskytovatelů outsourcingových služeb, jejich rozdělování platů ani do jiných záležitostí souvisejících se zaměstnáním účastníků školení.
        </li>
        <li>
          <strong>Vyjasnění právního vztahu</strong><br/>
          Pracovní vztah mezi účastníky školení a jejich příslušnými poskytovateli outsourcingových služeb zůstává tímto programem školení a zkoušek nedotčen. Mezi naší společností a účastníky školení neexistuje žádný pracovní vztah, ani tento program školení a zkoušek zaměřený na sdílení znalostí nezakládá žádný faktický pracovní vztah s účastníky školení. Veškerá práva a povinnosti vyplývající z pracovního vztahu zůstávají výhradně mezi poskytovateli outsourcingových služeb a účastníky školení.
        </li>
        <li>
          <strong>Použití výsledků zkoušek</strong><br/>
          Výsledky zkoušek budou použity pouze k následujícím účelům:
          <ol type="1">
            <li>Budou sloužit jako reference pro optimalizaci a zlepšování interních kurzů naší společnosti;</li>
            <li>Budou poskytovány poskytovatelům outsourcingových služeb jako důkaz odborné způsobilosti účastníků školení, a to s ohledem na nezávislý úsudek a ochotu poskytovatelů outsourcingových služeb;</li>
            <li>Výsledky zkoušek nebudou zveřejněny ani poskytnuty žádné třetí straně.</li>
          </ol>
        </li>
      </ol>

      <p>
        Toto prohlášení nabývá účinnosti dnem zveřejnění. Účastí v programu školení a zkoušek účastníci školení toto prohlášení potvrzují a přijímají. Naše společnost si vyhrazuje právo na výklad a může toto prohlášení čas od času přiměřeně změnit, a to za předpokladu, že takové změny nezmění povahu tohoto školení a zkoušky, která nevychází z pracovního vztahu. V případě jakéhokoli sporu nebo nesrovnalosti mezi různými jazykovými verzemi má přednost anglická verze.
      </p>

      <div className={styles["footer"]}>
        Školicí tým mezinárodního oddělení společnosti Xiaomi<br/>
        Datum: {getLocalizedTime('cs-CZ')}
      </div>
    </div>
  );
}